import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getTableCellNodeFromLexicalNode, TableCellNode } from '@lexical/table';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import { Button } from '@mui/material';
import React from 'react';
import useFloatingEditorState, { FindNodeFunc } from '../Hooks/useFloatingEditorState';
import TableActionsMenu from './Components/TableActionsMenu';
import StyledPopover from './styles';

export const findTableCell: FindNodeFunc<TableCellNode> = (node, selection) => {
  if (!selection) return null;
  const cellParent = $getTableCellNodeFromLexicalNode(node);
  return cellParent as TableCellNode;
};

export default function FloatingTableCellEditor() {
  const [editor] = useLexicalComposerContext();
  const [activeEditor, current] = useFloatingEditorState(editor, findTableCell);
  const [openMenu, setOpenMenu] = React.useState(false);

  if (!current) return null;
  return (
    <StyledPopover
      anchorEl={activeEditor.getElementByKey(current.node.getKey())}
      open={!!current}
      keepMounted
      disableAutoFocus
      disableEnforceFocus
      transformOrigin={{ vertical: -2, horizontal: 'right' }}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      elevation={8}
      disableScrollLock
      marginThreshold={null}
    >
      <Button onClick={() => { setOpenMenu(true); }}>
        <KeyboardArrowDownRoundedIcon />
      </Button>
      {openMenu && (
        <TableActionsMenu
          onClose={() => { setOpenMenu(false); }}
          openMenu={openMenu}
          activeEditor={activeEditor}
          current={current}
        />
      )}
    </StyledPopover>
  );
}
